"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseUrl = void 0;
function parseUrl(url) {
    const protocol = url.match(/^(.*?:)/)?.[0] ?? 'https:';
    const hostname = url
        .replace(protocol, '')
        .replace(/^\/*/, '')
        .replace(/^\\*/, '')
        .split(/[\?\/]/)[0];
    return { protocol, hostname };
}
exports.parseUrl = parseUrl;
